import AlarmIcon from "assets/icons/alarm.svg?react";

export const contentEnum = {
  alarm: {
    title: "alarm.warning.title",
    body: "alarm.warning.description",
    Icon: AlarmIcon,
    iconFill: "primary",
    buttonKeys: {
      confirm: "activate",
      cancel: "buttons.cancel"
    }
  }
} as const;

export type ContentEnum = typeof contentEnum;
